import { createSelector } from '@reduxjs/toolkit';
import { selectFacilitiesOptions } from './selectFacilitiesOptions';
import { selectFacilitiesValue } from './selectFacilitiesValue';

export const selectFacilitiesFilter = createSelector(
  [selectFacilitiesValue, selectFacilitiesOptions],
  (value, options) => ({
    label: 'Удобства',
    value,
    options,
  }),
);
